import { render, staticRenderFns } from "./CanvasSelectionToolbar.vue?vue&type=template&id=52030bfa&scoped=true"
import script from "./CanvasSelectionToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasSelectionToolbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanvasSelectionToolbar.vue?vue&type=style&index=0&id=52030bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52030bfa",
  null
  
)

export default component.exports